import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, notification, Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Row, Form, Input, Col, Select, Collapse, Popconfirm, DatePicker } from "antd";
import { EditOutlined, DeleteOutlined, InfoCircleFilled, ClearOutlined } from "@ant-design/icons";

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
import { MinusCircleTwoTone, PlusCircleTwoTone } from "@ant-design/icons";
import QuestionnairesApi from "../common/Apis/QuestionnairesApi";
import StockApi from "../common/Apis/StockApi";
import AddStock from "../common/Models/GoodInward/AddStock";
import jsPDF from 'jspdf';
import EditStock from "../common/Models/GoodInward/EditStock";
import AddWasteProduct from "../common/Models/Waste/AddWasteProduct";
import Pagination from "../common/Pagination/Pagination";
import "../common/Pagination/Pagination.css";
import dayjs from 'dayjs';

import SuppliersApi from "../common/Apis/SuppliersApi";

const Stock = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const urlParams = new URLSearchParams(window.location.search);
  const invoice_id = urlParams.get("invoice_id");
  const URLbatchCode = urlParams.get("batch");
  const supplier_id = urlParams.get("supplier_id");
  
  const [Stocks, setStocks] = useState([]);
  const [FilteredStocks, setFilteredStocks] = useState([]);
  const [originalStocks, setOriginalStocks] = useState([]);
  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [formPaginate] = Form.useForm();
  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });

  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    applyPagination(FilteredStocks, 0, value);
  };

  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1;
    applyPagination(FilteredStocks, pageNew, PaginateLimit);
  };

  const [modalwasteVisible, setModalwasteVisible] = useState(false);
  const [modalwasteData, setModalwasteData] = useState("");

  const handleWasteStock = (ProductID) => {
    StockApi.SingleStock(ProductID)
      .then((response) => {
          console.log('Stock data:', response.payload);

          const stockData = response.payload;  
          setModalwasteData(stockData);
      })
      .catch((err) => {
        console.log(err);
      });
    setModalwasteVisible(true);
  };

  const handlwasteCloseModal = () => {
    setModalwasteVisible(false);
  };

  const getStock = useCallback(() => {
    if (URLbatchCode !== null) {
      StockApi.ListBatchCode(URLbatchCode)
        .then((response) => {
          const data = response?.payloadDto || [];
          setOriginalStocks(data);
          setStocks(data);
          setFilteredStocks(data);
          settotalPages(response.totalPages);
          setTotalElements(response.totalElements);
          applyPagination(data, 0, PaginateLimit);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      StockApi.ListStockInvoice(invoice_id, 0, 9999)
        .then((response) => {
          const data = response?.payloadDto || [];
          setOriginalStocks(data);
          setStocks(data);
          setFilteredStocks(data);
          settotalPages(response.totalPages);
          setTotalElements(response.totalElements);
          applyPagination(data, 0, PaginateLimit);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [invoice_id, URLbatchCode]);

  const applyPagination = (data, page, limit) => {
    const startIndex = page * limit;
    const endIndex = startIndex + limit;
    const paginatedData = data.slice(startIndex, endIndex);
    setStocks(paginatedData);
    setPaginatePage(page);
    settotalPages(Math.ceil(data.length / limit));
    setTotalElements(data.length);
  };

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  const [TotalCost, setTotalCost] = useState(null);
  const [InvoiceSupplier, setInvoiceSupplier] = useState(null);
  
  const getCostTotal = useCallback(() => {
    SuppliersApi.SingleSuppliers(supplier_id)
      .then((response) => {
        setInvoiceSupplier(response?.payload)
      })
      .catch((err) => {
        console.log(err);
      });
    StockApi.ListStockInvoiceCost(invoice_id,0,100)
      .then((response) => {
        let totalCost = 0;
        response?.payloadDto?.forEach((item) => {
          totalCost += ((parseFloat(item?.initQuantity)) * (item?.productDTOs[0]?.costPriceUoM2));
        });
        setTotalCost(totalCost)
      })
      .catch((err) => {
        console.log(err);
      });
  }, [supplier_id, invoice_id]);

  useEffect(() => {
    getStock();
    PageLoading();
    getCostTotal();
    setModalwasteVisible(false);
  }, [getStock, PageLoading]);

  const handleClear = () => {
    setIsLoading(true);
    
    // Reset all filter states
    setProductNameFilter("");
    setBatchCodeFilter("");
    setExpiryDateFrom(null);
    setExpiryDateTo(null);
    setFilterStock([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
    setFilterDateValues({});
    
    // Reset to all data from the original list
    const allData = originalStocks.length > 0 ? originalStocks : [];
    setFilteredStocks(allData);
    
    // Reset pagination to first page with all data
    const startIndex = 0;
    const endIndex = PaginateLimit;
    const paginatedData = allData.slice(startIndex, endIndex);
    setStocks(paginatedData);
    setCurrentPage(1);
    setPaginatePage(0);
    settotalPages(Math.ceil(allData.length / PaginateLimit));
    setTotalElements(allData.length);
    
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  };

  const formRef = useRef(null);

  // New filter states
  const [productNameFilter, setProductNameFilter] = useState("");
  const [batchCodeFilter, setBatchCodeFilter] = useState("");
  const [expiryDateFrom, setExpiryDateFrom] = useState(null);
  const [expiryDateTo, setExpiryDateTo] = useState(null);

  const [filterStock, setFilterStock] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleAddfilterStock = () => {
    setFilterStock([
      ...filterStock,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    
    // Start with original data
    let allData = originalStocks.length > 0 ? originalStocks : [];
    
    // Filter by Product Name
    if (productNameFilter.trim()) {
      allData = allData.filter(item => 
        item?.productDTOs[0]?.productName?.toLowerCase().includes(productNameFilter.toLowerCase())
      );
    }
    
    // Filter by Batch Code
    if (batchCodeFilter.trim()) {
      allData = allData.filter(item => 
        item?.batchCode?.toLowerCase().includes(batchCodeFilter.toLowerCase())
      );
    }
    
    // Filter by Expiry Date Range
    if (expiryDateFrom || expiryDateTo) {
      allData = allData.filter(item => {
        const expiryDate = parseInt(item?.expiryDate);
        if (expiryDateFrom && expiryDateTo) {
          return expiryDate >= expiryDateFrom.valueOf() && expiryDate <= expiryDateTo.valueOf();
        } else if (expiryDateFrom) {
          return expiryDate >= expiryDateFrom.valueOf();
        } else if (expiryDateTo) {
          return expiryDate <= expiryDateTo.valueOf();
        }
        return true;
      });
    }
    
    setFilteredStocks(allData);
    applyPagination(allData, 0, PaginateLimit);
    setCurrentPage(1);
    
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  };

  const CurrencyConvert = (value) => {
    const formattedNumber = new Intl.NumberFormat('en-US').format(value);
    return formattedNumber;
  };

  const handleChangeTitle = (FiltergetStockIndex, value) => {
    const newfilterStock = [...filterStock];
    newfilterStock[FiltergetStockIndex].title = value;
    setFilterStock(newfilterStock);
  };

  const handleChangeAnswertype = (FiltergetStockIndex, value) => {
    const newfilterStock = [...filterStock];
    newfilterStock[FiltergetStockIndex].answerType = value;
    setFilterStock(newfilterStock);
  };

  const handleChangename = (FiltergetStockIndex, value) => {
    const newfilterStock = [...filterStock];
    if (value && typeof value === 'object' && value.$d) {
      const timestamp = value.valueOf();
      newfilterStock[FiltergetStockIndex].name = timestamp;
      setFilterDateValues(prev => ({
        ...prev,
        [FiltergetStockIndex]: value
      }));
    } else {
      newfilterStock[FiltergetStockIndex].name = value;
    }
    setFilterStock(newfilterStock);
  };

  const paginatedData = Stocks;

  const handlePrintButtonClick = () => {
    const fontSize = 10;
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [210, 297],
    });

    let yPos = 35;
    doc.setFontSize(fontSize);
    const currentDate = new Date().toLocaleDateString();
    const currentTime = new Date().toLocaleTimeString();
    const promises = [];

    const totalPages = Math.ceil(FilteredStocks.length / PaginateLimit);
    
    for (let i = 0; i < totalPages; i++) {
      const pageData = FilteredStocks.slice(i * PaginateLimit, (i + 1) * PaginateLimit);
      
      doc.setFont('Poppins', 'bold');
      doc.text(`Stock History Invoice # ${invoice_id}`, 90, 10);
      doc.setFont('Poppins', 'normal');
      doc.setFontSize(10);
      doc.text(`Supplier : ${InvoiceSupplier?.supplierName}`, 10, 20);
      doc.text(`Total Cost :  ${pageData[0]?.productDTOs[0]?.currency + " " + CurrencyConvert(TotalCost)}`, 10, 25);
      doc.text(`Date : ${currentDate}`, 170, 20);
      doc.text(`Time : ${currentTime}`, 170, 25);
      doc.setFontSize(fontSize);
      
      const invoiceX = 10;
      const batchCodeX = 30;
      const oubdX = 50;
      const productNameX = 85;
      const uom1X = 125;
      const uom2X = 150;
      const costX = 180;

      doc.text('Invoice #', invoiceX, yPos);
      doc.text('Batch Code', batchCodeX, yPos);
      doc.text('OUBD', oubdX, yPos);
      doc.text('Product Name', productNameX, yPos);
      doc.text('Qty(UOM1)', uom1X, yPos);
      doc.text('Qty(UOM2)', uom2X, yPos);
      doc.text('Cost (UOM2)', costX, yPos);
      doc.rect(5, yPos - 5, 195, 10);

      yPos += 10;

      const formatValue = (value) => {
        const normalStr = value.toLocaleString('fullwide', {
          useGrouping: false,
          maximumFractionDigits: 20
        });
        const match = normalStr.match(/^-?\d+(?:\.\d{0,3})?/);
        return match ? match[0] : '0';
      };

      pageData.forEach(row => {
        const invoiceNumber = row?.invoiceNumber;
        const batchCode = row?.batchCode;
        const oubd = formatDate(row?.expiryDate);
        const productName = row?.productDTOs[0]?.productName;
        const unitOfMeasurement1 = formatValue(
          parseFloat(row?.initQuantity) / parseFloat(row?.productDTOs[0]?.unitOfMeasurement2 || 1)
        ) + " " + row?.productDTOs[0]?.unitUomOne;
        const initQuantity = row?.initQuantity + " " + row?.productDTOs[0]?.unitUomTwo;
        const cost = row?.productDTOs[0]?.currency + " " + CurrencyConvert(((parseFloat(row?.initQuantity)) * (row?.productDTOs[0]?.costPriceUoM2)));

        yPos += 6;
        doc.text(invoiceNumber, invoiceX, yPos);
        doc.text(batchCode, batchCodeX, yPos);
        doc.text(oubd, oubdX, yPos);
        doc.text(productName, productNameX, yPos);
        doc.text(unitOfMeasurement1, uom1X, yPos);
        doc.text(initQuantity, uom2X, yPos);
        doc.text(cost, costX, yPos);
        doc.rect(5, yPos - 5, 195, 10);
        yPos += 4;
      });
      
      if (i < totalPages - 1) {
        doc.addPage();
        yPos = 35;
      }
    }

    window.open(doc.output('bloburl'), '_blank');
  };

  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">
          <td style={{ width: "12%" }} className="pt-3 ">
            {item?.invoiceNumber}
          </td>
          <td style={{ width: "25%", verticalAlign: 'top' }} className="pt-3">
            <div style={{
              overflowX: 'auto',
              overflowY: 'hidden',
              whiteSpace: 'nowrap',
              maxWidth: '200px',
              marginBottom: '10px',
              marginTop: '-3px',
              padding: '0px 0px 20px',
              display: 'block',
            }}>
              {item?.batchCode || '-'}
            </div>
          </td>
          {URLbatchCode === null && (
            <td style={{ width: "12%" }} className="pt-3 ">
              {formatDate(item?.expiryDate)}
            </td>
          )}
          <td style={{ width: "15%" }} className="pt-3 ">
            {item?.productDTOs[0]?.productName}
          </td>
          <td style={{ width: "10%", textAlign: 'center' }} className="pt-3 ">
            {(function() {
              const value = parseFloat(item?.initQuantity) / parseFloat(item?.productDTOs[0]?.unitOfMeasurement2 || 1);
              const normalStr = value.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 20 });
              const match = normalStr.match(/^-?\d+(?:\.\d{0,3})?/);
              return match ? match[0] : '0';
            })()} {item?.productDTOs[0]?.unitUomOne}
          </td>
          <td style={{ width: "10%", textAlign: 'center' }} className="pt-3">
            {item?.initQuantity} {item?.productDTOs[0]?.unitUomTwo}
          </td>
          <td style={{ width: "10%", textAlign: 'center' }} className="pt-3">
            {item?.productDTOs[0]?.currency} {((parseFloat(item?.initQuantity)) * (item?.productDTOs[0]?.costPriceUoM2)).toFixed(1)}
          </td>
          {URLbatchCode !== null && (
            <td style={{ width: "12%" }} className="pt-3 text-center">
              {item?.unitOfMeasurement1} {item?.unit}
            </td>
          )}
          <td style={{ width: "5%", textAlign: 'center' }} className="pt-3">
            {item?.allergensDTOList &&
              <Tooltip placement="top" title={(
                <div>
                  {item?.allergensDTOList?.map((allergen, index) => (
                    <div key={index}>{allergen?.allergensName}</div>
                  ))}
                </div>
              )}>
                <InfoCircleFilled className="inforIcon" />
              </Tooltip>
            }
          </td>
          <td style={{ width: "25%" }}>
            <div className="d-flex gap-2 text-center">
              {URLbatchCode === null ? (
                <>
                  <Button
                    onClick={() => handleOpenEditModal(item.id)}
                    className="btn btn-primary btn-save table-action icon-center"
                    style={{ boxShadow: "none", flex: 1, width: "150px" }}
                  >
                    <EditOutlined />
                    Edit
                  </Button>
                  <Popconfirm
                    title="Delete Stock Item"
                    description="Are you sure you want to delete this stock item?"
                    onConfirm={() => handleDeleteStockItem(item.id)}
                    okText="Yes"
                    cancelText="No"
                    okButtonProps={{ danger: true }}
                  >
                    <Button
                      danger
                      className="btn btn-danger table-action icon-center"
                      style={{ color: "red", boxShadow: "none", flex: 1 }}
                    >
                      <DeleteOutlined />
                      Delete
                    </Button>
                  </Popconfirm>
                </>
              ) : (
                <Button
                  onClick={() => handleWasteStock(item.id)}
                  className="btn btn-primary btn-save table-action icon-center"
                  style={{ boxShadow: "none", width: "100%" }}
                >
                  <ClearOutlined />
                  Waste
                </Button>
              )}
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={9} className="text-center ">
            <img
              src="/assest/Images/emptyIcon.svg"
              className="logo-png mt-3"
              style={{ width: "10%" }}
              alt="No data"
            />
          </td>
        </tr>
      );
    }
  };

  function formatDate(date) {
    const dateNew = parseInt(date, 10);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Date(dateNew).toLocaleDateString(
      "en-US",
      options
    );
    const [month, day, year] = formattedDate.split(" ");
    const capitalizedMonth = month.toUpperCase();
    return `${day} ${capitalizedMonth} ${year}`;
  }

  const [modalAddVisible, setModalAddVisible] = useState(false);
  const handleOpenAddModal = () => {
    setModalAddVisible(true);
  };
  const handleAddCloseModal = () => {
    setModalAddVisible(false);
  };

  const [modalEditVisible, setModalEditVisible] = useState(false);
  const [modalEditData, setModalEditData] = useState("");

  const handleOpenEditModal = (StockID) => {
    StockApi.SingleStock(StockID)
      .then((response) => {
        setModalEditData(response.payload);
      })
      .catch((err) => {
        console.log(err);
      });
    setModalEditVisible(true);
  };
  
  const handleDeleteStockItem = (stockId) => {
  StockApi.DeleteStock(stockId)
    .then((response) => {
      notification.open({
        message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
        description: "Stock item deleted successfully",
        closeIcon: false,
        duration: 3,
        style: {
          backgroundColor: "#b3ffb3",
          color: "green",
        },
      });
      // Refresh the stock list after deletion
      getStock();
      PageLoading();
    })
    .catch((err) => {
      if (err.apiError?.status) {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Error</span>,
          description: err.apiError.message || "Failed to delete stock item",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#fff2f0",
            color: "red",
          },
        });
      } else {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Error</span>,
          description: "Failed to delete stock item. Please try again.",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#fff2f0",
            color: "red",
          },
        });
      }
    });
};

  const handlEditeCloseModal = () => {
    setModalEditVisible(false);
    getStock();
  };

  const [filterDateValues, setFilterDateValues] = useState({});

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader onPrintResponse={handlePrintButtonClick} />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <Collapse>
              <Panel
                header={
                  <h5 className="mb-0">
                    <b>Filter</b>
                  </h5>
                }
                key="1"
              >
                <Row gutter={12} className="pt-2" align="bottom">
                  <Col span={5}>
                    <Form.Item label="Product Name" className="text-lable" style={{ marginBottom: 0 }}>
                      <Input
                        placeholder="Search by Product Name"
                        value={productNameFilter}
                        onChange={(e) => setProductNameFilter(e.target.value)}
                        className="control-input"
                        style={{ height: '38px' }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="Batch Code" className="text-lable" style={{ marginBottom: 0 }}>
                      <Input
                        placeholder="Search by Batch Code"
                        value={batchCodeFilter}
                        onChange={(e) => setBatchCodeFilter(e.target.value)}
                        className="control-input"
                        style={{ height: '38px' }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item label="From Date" className="text-lable" style={{ marginBottom: 0 }}>
                      <DatePicker
                        className="control-input"
                        placeholder="From Date"
                        value={expiryDateFrom}
                        onChange={(date) => setExpiryDateFrom(date)}
                        format="DD MMM YYYY"
                        style={{ width: '100%', height: '38px' }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item label="To Date" className="text-lable" style={{ marginBottom: 0 }}>
                      <DatePicker
                        className="control-input"
                        placeholder="To Date"
                        value={expiryDateTo}
                        onChange={(date) => setExpiryDateTo(date)}
                        format="DD MMM YYYY"
                        style={{ width: '100%', height: '38px' }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={3} style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '13px' }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="btn btn-primary btn-save table-action icon-center"
                      style={{ height: '38px', width: '100%' }}
                    >
                      Filter
                    </Button>
                  </Col>
                  <Col span={1}>
                    {/* Spacer column */}
                  </Col>
                  <Col span={2} style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '13px' }}>
                    <Button
                      type="reset"
                      htmlType="reset"
                      onClick={() => handleClear()}
                      style={{ color: "#0b5ed7", height: '38px', width: '100%' }}
                      className="btn btn-primary btn-back table-action icon-center"
                    >
                      Clear
                    </Button>
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <Link
                  className="btn btn-primary btn-back m-0 my-2 "
                  onClick={handleGoBack}
                >
                  Back
                </Link>
              </div>
              <div>
                <Form form={formPaginate}>
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>
              </div>
            </div>
            <table className="table users-table">
              <thead>
                <tr style={{ verticalAlign: 'top' }}>
                  <th>Invoice #</th>
                  <th>Batch Code</th>
                  {URLbatchCode === null && (
                    <th className="text-center">OUBD<br /> <p className="mb-0 pb-0" style={{ color: 'gray', fontSize: '12px' }}>(Original Used by Date)</p></th>
                  )}
                  <th>Product Name</th>
                  <th className="text-center">Qty(UOM1)</th>
                  <th>Qty(UOM2)</th>
                  <th>Cost (UOM2)</th>
                  {URLbatchCode !== null && (
                    <th style={{ textAlign: "center" }}>Open Stock (UOM2)</th>
                  )}
                  <th className="text-center">Allergens</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
              <Pagination
                currentPage={currentPage}
                totalPages={PaginatetotalPages}
                onPageChange={handlePageChange}
                maxVisiblePages={5}
                showPageInfo={true}
                totalItems={totalElements}
                pageSize={PaginateLimit}
              />
            )}
          </div>
        </Content>
        {modalAddVisible &&
          <AddStock
            visible={modalAddVisible}
            onClose={handleAddCloseModal}
            ProductDetails={modalEditData}
          />
        }
        {modalEditVisible &&
          <EditStock
            visible={modalEditVisible}
            onClose={handlEditeCloseModal}
            ProductDetails={modalEditData}
          />
        }
        {modalwasteVisible &&
          <AddWasteProduct
            ProductId={modalwasteData?.productDTOs?.[0]?.id}
            visible={modalwasteVisible}
            onClose={handlwasteCloseModal}
            ProductDetails={modalwasteData}
          />
        }
      </Layout>
    </Layout>
  );
};

export default Stock;